import React from 'react'
import logoimg from '../../assets/MK1.3.png';
import exam from '../../assets/exams.png'
import exam2 from '../../assets/examsf2.png';
import chat from '../../assets/chat.png';
import news from '../../assets/news.png';
import qb from '../../assets/QB.png';
import live from '../../assets/live3.png';
import books from '../../assets/books.png';
import people from '../../assets/people.png';
import { useNavigate } from 'react-router-dom';
import {setToken,getToken,removeToken} from "../../Data/authToken.js";


function Paging() {

  const navigate = useNavigate();

  return (
    <div className=' bg-[white] text-[#91918f] flex flex-col min-h-screen text-xl font-bold pb-40 '>
      <img className=' w-[70%] ml-[15%] lg:w-[40%] lg:ml-[30%] mt-[40px] rounded-full' src={logoimg} alt="mohamed khamis" />
      <div className='flex flex-col w-full '>
        <div onClick={()=>{navigate("/students")}} className='flex flex-row justify-between items-center w-[80%] ml-[10%] lg:w-[40%] lg:ml-[30%] border-2 hover:text-white border-[#e9ad03] hover:bg-[#e9ad03] cursor-pointer  rounded-full px-3 py-1 mb-8 '>
            <img src={people} className='w-14 rounded-full ' />
            <p> طلاب </p>
        </div>
        <div onClick={()=>{navigate("/courses")}} className='flex flex-row justify-between items-center w-[80%] ml-[10%] lg:w-[40%] lg:ml-[30%] border-2 hover:text-white border-[#e9ad03] hover:bg-[#e9ad03] cursor-pointer  rounded-full px-3 py-1 mb-8 '>
            <img src={books} className='w-14 rounded-full ' />
            <p> كورسات </p>
        </div>
        <div onClick={()=>{navigate("/news")}} className='flex flex-row justify-between items-center w-[80%] ml-[10%] lg:w-[40%] lg:ml-[30%] border-2 hover:text-white border-[#e9ad03] hover:bg-[#e9ad03] cursor-pointer  rounded-full px-3 py-1 mb-8 '>
            <img src={news} className='w-14 rounded-full ' />
            <p> الأخبار </p>
        </div>
        <div onClick={()=>{navigate("/messages")}} className='flex flex-row justify-between items-center w-[80%] ml-[10%] lg:w-[40%] lg:ml-[30%] border-2 hover:text-white border-[#e9ad03] hover:bg-[#e9ad03] cursor-pointer  rounded-full px-3 py-1 mb-8 '>
            <img src={chat} className='w-14 rounded-full ' />
            <p> الرسائل </p>
        </div>
        <div onClick={()=>{navigate("/questionBank")}} className='flex flex-row justify-between items-center w-[80%] ml-[10%] lg:w-[40%] lg:ml-[30%] border-2 hover:text-white border-[#e9ad03] hover:bg-[#e9ad03] cursor-pointer  rounded-full px-3 py-1 mb-8 '>
            <img src={qb} className='w-14 rounded-lg ' />
            <p> بنك أسئلة </p>
        </div>
        <div onClick={()=>{navigate("/generalexams")}} className='flex flex-row justify-between items-center w-[80%] ml-[10%] lg:w-[40%] lg:ml-[30%] border-2 hover:text-white border-[#e9ad03] hover:bg-[#e9ad03] cursor-pointer  rounded-full px-3 py-1 mb-8 '>
            <img src={exam2} className='w-14 rounded-lg ' />
            <p> امتحانات عامة </p>
        </div>
        <div onClick={()=>{navigate("/exams")}} className='flex flex-row justify-between items-center w-[80%] ml-[10%] lg:w-[40%] lg:ml-[30%] border-2 hover:text-white border-[#e9ad03] hover:bg-[#e9ad03] cursor-pointer  rounded-full px-3 py-1 mb-8 '>
            <img src={exam} className='w-14  ' />
            <p>متابعة امتحانات </p>
        </div>
        <div onClick={()=>{}} className='flex flex-row justify-between items-center w-[80%] ml-[10%] lg:w-[40%] lg:ml-[30%] border-2 hover:text-white border-[#e9ad03] hover:bg-[#e9ad03] cursor-pointer  rounded-full px-3 py-1 mb-8 '>
            <img src={live} className='w-14 rounded-full ' />
            <p>لايف</p>
        </div>
        <div onClick={()=>{navigate("/addGroup")}} className='flex flex-row justify-between items-center w-[80%] ml-[10%] lg:w-[40%] lg:ml-[30%] border-2 hover:text-white border-[#e9ad03] hover:bg-[#e9ad03] cursor-pointer  rounded-full px-3 py-1 mb-8 '>
            <img src={people} className='w-14 rounded-full ' />
            <p>مجموعات</p>
        </div>
      </div>
    </div>
  )
}

export default Paging
